module.exports = __webpack_public_path__ + "img/ab553db3e638836f5f01a3ecf948fb14.20235a55.jpg";